import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => { setPage(null); setNotFound(false); api.get(`/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => setNotFound(true)); }, [slug]);

  if (notFound) return <div className="max-w-2xl mx-auto px-4 py-24 text-center"><p className="font-serif text-2xl">Sayfa bulunamadı</p><Link to="/" className="text-forest font-semibold mt-4 inline-block">Ana sayfaya dön</Link></div>;
  if (!page) return <div className="max-w-2xl mx-auto px-4 py-24 text-center text-stone-500">Yükleniyor...</div>;

  return (
    <div data-testid="static-page" className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="font-serif text-3xl sm:text-4xl text-forest">{page.title}</h1>
      <article className="mt-6 bg-white rounded-2xl border border-stone-200/80 p-6 sm:p-8 text-stone-700 leading-relaxed whitespace-pre-line text-sm sm:text-base">{page.content}</article>
    </div>
  );
}
